import styled from '@emotion/styled';
import { rgba } from 'polished';
import React from 'react';
import { typography } from '../../styles/typography';

type ITrProps = Pick<React.HTMLProps<HTMLTableRowElement>, 'onClick'>;

export interface IProps extends ITrProps {
  active?: boolean;
  colorTheme?: 'primary' | 'secondary' | 'ternary';
  firstColumnTitle?: boolean;
  [key: string]: any;
}

const Host = styled.tr<{
  active?: boolean;
  colorTheme?: string;
  firstColumnTitle: boolean;
}>`
  min-height: 68px;

  &:last-child td {
    border-color: ${(props) => rgba(props.theme.colors.foreground, 0.5)};
  }

  &:first-child td {
    &:before {
      top: 0px;
    }
  }

  th:first-child {
    ${({ firstColumnTitle }) => firstColumnTitle && typography.h5}
  }

  td {
    border-color: ${(props) => rgba(props.theme.colors.primary, 0.1)};
    transition: border-color 100ms ease-in;

    &:before {
      content: '';

      position: absolute;
      top: 0;
      left: 0;
      right: 0;

      height: 1px;
      width: 100%;

      transition: border-color 100ms ease-in;
    }

    &:after {
      content: '';

      position: absolute;
      bottom: -1px;
      left: 0;
      right: 0;

      height: 2px;
      width: 100%;
    }

    ${(props) => {
      if (props.active && props.colorTheme !== undefined)
        return `
        
        background-color: ${
          props.colorTheme !== 'primary'
            ? props.theme.shades[`${props.colorTheme}1`]
            : '#f0f4fb'
        };
        
        position: relative;


        &:before {
          content: '';

          position: absolute;
          top: -1px;
          left: 0;
          right: 0;

          height: 1px;
          width: 100%;

          background-color: ${
            props.colorTheme !== 'primary'
              ? props.theme.shades[`${props.colorTheme}1`]
              : '#f0f4fb'
          };
        }

          &:after {
            content: '';

            position: absolute;
            bottom: -1px;
            left: 0;
            right: 0;

            height: 2px;
            width: 100%;

            background-color: ${
              props.colorTheme !== 'primary'
                ? props.theme.shades[`${props.colorTheme}3`]
                : '#cadbf0'
            };
          }    
      `;
    }};
  }
`;

export const Tr = ({ children, firstColumnTitle = true, ...rest }: IProps) => {
  return (
    <Host firstColumnTitle={firstColumnTitle} {...rest}>
      {children}
    </Host>
  );
};
